// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__a0Coz","errors":"Errors_errors__3TA5Y"};